module.exports = __webpack_public_path__ + "static/media/OS10.53216c00.svg";